// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"e8-z"};